import { REQUEST_SUBMIT_FORM, RECEIVE_SUBMIT_FORM } from '../actions/submitting'
import { RESET_FLOW } from '../actions/reset'

export const initialState = {
  isFetching: false,
  status: 'initial',
}

function submitting(state = initialState, action = {}) {
  switch (action.type) {
    case REQUEST_SUBMIT_FORM:
      return {
        ...state,
        isFetching: true,
      }
    case RECEIVE_SUBMIT_FORM:
      return {
        ...state,
        isFetching: false,
        status: action.data,
      }
    case RESET_FLOW:
      return initialState
    default:
      return state
  }
}

export default submitting
